import { assertUnreachable } from '@dh/utils';

const strapiBaseURL = process.env.STRAPI_BASE_URL;

enum Endpoint {
    ABOUT,
    BUDGETS,
    CHANGE_PASSWORD,
    COMMENTS_POST,
    CONFIRMATION,
    CONTACTS,
    CONTACTDESCRIPTION,
    COURSES,
    DELETE_FILES,
    LOGIN,
    FORGOT_PASSWORD,
    FAQS,
    FILEMOVER,
    IMPRINT,
    INSTITUTIONS,
    LANGUAGES,
    ONBOARDING,
    POSTS,
    PRINCIPLES,
    PRIVACY,
    PROJECTS,
    REGISTER,
    RESEND_CONFIRMATION,
    RESET_PASSWORD,
    SIMPLE_LANGUAGE,
    TOPICS,
    TESTIMONIALS,
    UPLOAD,
    USER_GROUPS,
    USERS,
    PROJECT_TOPICS,
    MATCHING_CONFIG,
    MATCHES,
    MATCH,
    SHARE_CONTACT,
    SEND_EMAIL,
    EXCHANGE_COMMENTS,
    EXCHANGE_REPLIES,
    SOFTWARES
}

const getStrapiEndpoint = (endpoint: Endpoint) => {
    if (!strapiBaseURL)
        throw new Error(
            "Could not compose API endpoint: No strapiBaseURL defined!\nYou are probably trying to fetch from client side. Add 'use server ' in front of your fetch API file."
        );
    switch (endpoint) {
        case Endpoint.ABOUT:
            return `${strapiBaseURL}/api/about`;
        case Endpoint.BUDGETS:
            return `${strapiBaseURL}/api/x-budget`;
        case Endpoint.CHANGE_PASSWORD:
            return `${strapiBaseURL}/api/auth/change-password`;
        case Endpoint.COMMENTS_POST:
            return `${strapiBaseURL}/api/comments/api::post.post:`;
        case Endpoint.CONFIRMATION:
            return `${strapiBaseURL}/api/auth/email-confirmation`;
        case Endpoint.CONTACTS:
            return `${strapiBaseURL}/api/contacts`;
        case Endpoint.CONTACTDESCRIPTION:
            return `${strapiBaseURL}/api/contact-description`;
        case Endpoint.COURSES:
            return `${strapiBaseURL}/api/courses`;
        case Endpoint.DELETE_FILES:
            return `${strapiBaseURL}/api/upload/files`;
        case Endpoint.LOGIN:
            return `${strapiBaseURL}/api/auth/local`;
        case Endpoint.FAQS:
            return `${strapiBaseURL}/api/faqs`;
        case Endpoint.FILEMOVER:
            return `${strapiBaseURL}/api/moveFilesToFolder`;
        case Endpoint.FORGOT_PASSWORD:
            return `${strapiBaseURL}/api/auth/forgot-password`;
        case Endpoint.IMPRINT:
            return `${strapiBaseURL}/api/imprint-text`;
        case Endpoint.INSTITUTIONS:
            return `${strapiBaseURL}/api/institutions`;
        case Endpoint.LANGUAGES:
            return `${strapiBaseURL}/api/languages`;
        case Endpoint.ONBOARDING:
            return `${strapiBaseURL}/api/onboardings`;
        case Endpoint.POSTS:
            return `${strapiBaseURL}/api/posts`;
        case Endpoint.PRINCIPLES:
            return `${strapiBaseURL}/api/principles`;
        case Endpoint.PRIVACY:
            return `${strapiBaseURL}/api/privacy-text`;
        case Endpoint.PROJECTS:
            return `${strapiBaseURL}/api/projects`;
        case Endpoint.REGISTER:
            return `${strapiBaseURL}/api/auth/local/register`;
        case Endpoint.RESEND_CONFIRMATION:
            return `${strapiBaseURL}/api/auth/send-email-confirmation`;
        case Endpoint.RESET_PASSWORD:
            return `${strapiBaseURL}/api/auth/reset-password`;
        case Endpoint.SIMPLE_LANGUAGE:
            return `${strapiBaseURL}/api/simple-language`;
        case Endpoint.TESTIMONIALS:
            return `${strapiBaseURL}/api/testimonials`;
        case Endpoint.TOPICS:
            return `${strapiBaseURL}/api/topics`;
        case Endpoint.UPLOAD:
            return `${strapiBaseURL}/api/upload`;
        case Endpoint.USERS:
            return `${strapiBaseURL}/api/users`;
        case Endpoint.USER_GROUPS:
            return `${strapiBaseURL}/api/usergroups`;
        case Endpoint.PROJECT_TOPICS:
            return `${strapiBaseURL}/api/project-topics`;
        case Endpoint.MATCHING_CONFIG:
            return `${strapiBaseURL}/api/matching-config`;
        case Endpoint.MATCHES:
            return `${strapiBaseURL}/api/project-matchings`;
        case Endpoint.MATCH:
            return `${strapiBaseURL}/api/matches`;
        case Endpoint.SHARE_CONTACT:
            return `${strapiBaseURL}/api/matches/update-contact-status`;
        case Endpoint.SEND_EMAIL:
            return `${strapiBaseURL}/api/matches/send-contact-mail`;
        case Endpoint.EXCHANGE_COMMENTS:
            return `${strapiBaseURL}/api/exchange-comments`;
        case Endpoint.EXCHANGE_REPLIES:
            return `${strapiBaseURL}/api/exchange-replies`;
        case Endpoint.SOFTWARES:
            return `${strapiBaseURL}/api/softwares`;
        default:
            assertUnreachable(endpoint);
    }
};

enum ROUTES {
    Home = '/',
    Login = '/login',
    Signup = '/signup',
    Profile = '/profile',
    EditProfile = '/profile/edit',
    EditInstitution = '/profile/institution/edit',
    UserManagement = '/user-management',
    CompanyDetails = '/company/:companyId',
    Service = '/service',

    Contact = '/service?tab=contact',
    Faq = '/service?tab=faq',
    Privacy = '/service?tab=privacy',
    Imprint = '/service?tab=imprint',
    Projects = '/projects',
    ProjectDetails = '/projects/:projectId',
    Companies = '/companies',
    About = '/service?tab=about',
    SimpleLanguage = '/simple-language',
    Matching = '/matching',
    ConfirmationSent = '/confirm?sent=true',
    ResendConfirmation = '/confirm',
    ResetPassword = '/reset-password',
    SearchResults = '/searchresults'
}

const smallDrawerWidth = 80;
const bigDrawerWidth = 360;

const missingTopicLink = '';

const ONE_GB_IN_BYTES = 1073741824;

const DELETED_COMMENT = 'DELETED_COMMENT';

const ProlongDays = 30;
const DaysBeforeProlong = 7;

export {
    ProlongDays,
    DaysBeforeProlong,
    strapiBaseURL,
    ROUTES,
    Endpoint,
    getStrapiEndpoint,
    smallDrawerWidth,
    bigDrawerWidth,
    missingTopicLink,
    ONE_GB_IN_BYTES,
    DELETED_COMMENT
};
